import { zergApi } from "@/service/zerg";

class AdministrativePayrollService {

    async calculatePayroll(params) {
        try {
            const data = await zergApi.post("/rrhh/payroll/employee/calculate-payroll-fortnight", params);
            return data;
        } catch (error) {
            throw error;
        }
    };

    async calculateMonthlyPayroll(params) {
        try {
            const data = await zergApi.post("/rrhh/payroll/employee/calculate-payroll-monthly", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async listPayroll(params) {
        try {
            const data = await zergApi.post("/rrhh/payroll/employee/list-payroll", params);
            return data;
        } catch (error) {
            throw error;
        }
    };
    async getAdministrativePayrollById(params) {
        try {
            const data = await zergApi.post("/rrhh/payroll/employee/get-payroll-by-id", params);
            return data;
        } catch (error) {
            throw error;
        }
    };

    async recalculatePayroll(params) {
        try {
            const data = await zergApi.post("/rrhh/payroll/employee/recalculate-payroll", params);
            return data;
        } catch (error) {
            throw error;
        }
    };

    async aprobarPlanillaAdministrativo(params) {
        try {
            const data = await zergApi.post("/rrhh/payroll/employee/aprobar-planilla-administrativo", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async consultarPlanillaAdministrativo(batchId) {
        try {
            const { data } = await zergApi.get(`/rrhh/payroll/employee/consultar-planilla-administrativo/${batchId}`);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getAdministrativePayrollTracking(params) {
        try {
            const data = await zergApi.post("/rrhh/payroll/employee/get-payroll-tracking", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async addDiscountToAdministrativePayroll(params) {
        try {
            const data = await zergApi.post("/rrhh/payroll/employee/add-discount-to-administrative-payroll", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getDataPlanillaMensual(params) {
        try {
            const data = await zergApi.post("/rrhh/payroll/employee/get-data-planilla-mensual", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async deleteAdministrativePayroll(params) {
        try {
            const data = await zergApi.post("/rrhh/payroll/employee/delete-administrative-payroll", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async anularPlanillaAdministrativa(params) {
        try {
            const data = await zergApi.post("/rrhh/payroll/employee/anular-planilla-administrativa", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

}

export default new AdministrativePayrollService();